import { lazy } from 'react';

export const LazyDataUpdate = lazy(() =>
  lazyRetry(
    () => import('~/modules/identification/components/DataUpdate/DataUpdate.tsx'),
    'DataUpdate'
  )
);
export const LazySignIn = lazy(() =>
  lazyRetry(() => import('~/modules/auth/sign-in/SignIn.tsx'), 'SignIn')
);
export const LazySignUp = lazy(() =>
  lazyRetry(() => import('~/modules/auth/sign-up/SignUp.tsx'), 'SignUp')
);
export const LazyChangePassword = lazy(() =>
  lazyRetry(() => import('~/modules/auth/change-password/ChangePassword.tsx'), 'ChangePassword')
);
export const LazyMainPage = lazy(() =>
  lazyRetry(() => import('~/modules/main-page/MainPage.tsx'), 'MainPage')
);
export const LazyManagerLayout = lazy(() =>
  lazyRetry(() => import('~/modules/main-page/manager-layout/ManagerLayout.tsx'), 'ManagerLayout')
);
export const LazyApplicationReports = lazy(() =>
  lazyRetry(
    () => import('~/components/ApplicationReports/ApplicationReports.tsx'),
    'ApplicationReports'
  )
);
export const LazySignInManager = lazy(() =>
  lazyRetry(() => import('~/modules/auth/sign-in/SignInManager.tsx'), 'SignInManager')
);
export const LazyNotFound = lazy(() =>
  lazyRetry(() => import('~/components/NotFound/NotFound.tsx'), 'NotFound')
);
export const LazyAssetManagerForm = lazy(() =>
  lazyRetry(
    () => import('~/modules/identification/forms/AssetManagerForm/AssetManagerForm'),
    'AssetManagerForm'
  )
);
export const LazyInvalidSessionMessage = lazy(() =>
  lazyRetry(
    () => import('~/components/InvalidSessionMessage/InvalidSessionMessage.tsx'),
    'InvalidSessionMessage'
  )
);
export const LazyPersonalDataMainPage = lazy(() =>
  lazyRetry(
    () => import('~/modules/processing-personal/PersonalDataMainPage/PersonalDataMainPage'),
    'PersonalDataMainPage'
  )
);
export const LazyPersonalDataApplication = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/processing-personal/PersonalDataApplicationForm/PersonalDataApplication.tsx'),
    'PersonalDataApplication'
  )
);
export const LazyPersonalDataCreateApplicationByClient = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/processing-personal/PersonalDataForm/CreateFormClient/CreateFormClient.tsx'),
    'PersonalDataCreateApplicationByClient'
  )
);
export const LazyPersonalDataCreateApplicationByManager = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/processing-personal/PersonalDataForm/CreateFormManager/CreateFormManager.tsx'),
    'PersonalDataCreateApplicationByManager'
  )
);
export const LazyPersonalDataRevokeCreateApplicationByClient = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/processing-personal/PersonalDataForm/RevokeFormClient/RevokeFormClient.tsx'),
    'PersonalDataRevokeCreateApplicationByClient'
  )
);
export const LazyContactInformation = lazy(() =>
  lazyRetry(
    () => import('~/modules/remote-banking-contacts/ContactInformation/ContactInformation'),
    'ContactInformation'
  )
);
export const LazyRemoteBankingContactsAuthentication = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/remote-banking-contacts/Authentication/RemoteBankingContactsAuthentication'),
    'RemoteBankingContactsAuthentication'
  )
);
export const LazyCounterpartySelector = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/covenants/CovenantsDataForm/CovenantsFormByClient/components/CounterpartySelector.tsx'),
    'CounterpartySelector'
  )
);
export const LazyCovenantsApplicationByClient = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/covenants/CovenantsDataForm/CovenantsFormByClient/CovenantsApplicationByClient.tsx'),
    'CovenantsApplicationByClient'
  )
);
export const LazyCovenantsApplicationByManager = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/covenants/CovenantsDataForm/CovenantsFormByManager/CovenantsApplicationByManager.tsx'),
    'CovenantsApplicationByManager'
  )
);
export const LazyManagerApplicationReviewPage = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/covenants/CovenantsDataForm/CovenantsFormByManager/ManagerApplicationReviewPage.tsx'),
    'ManagerApplicationReviewPage'
  )
);
export const LazyApplicationFormPage = lazy(() =>
  lazyRetry(
    () => import('~/modules/covenants/CovenantsDataApplicationForm/CovenantsApplicationPage.tsx'),
    'ApplicationFormPage'
  )
);
export const LazyCovenantsLayout = lazy(() =>
  lazyRetry(() => import('~/modules/covenants/components/CovenantsLayout.tsx'), 'CovenantsLayout')
);
export const LazySegmentsManagerPage = lazy(() =>
  lazyRetry(
    () => import('~/modules/covenants/CovenantsSegmentsManager/SegmentsManagerPage.tsx'),
    'SegmentsManagerPage'
  )
);
export const LazyUsapokAdministrationPage = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/supervisor-administration/SupervisorAdministrationRoutePages.tsx').then(
        ({ UsapokAdministrationPage }) => ({ default: UsapokAdministrationPage })
      ),
    'UsapokAdministrationPage'
  )
);
export const LazyUmvnAdministrationPage = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/supervisor-administration/SupervisorAdministrationRoutePages.tsx').then(
        ({ UmvnAdministrationPage }) => ({ default: UmvnAdministrationPage })
      ),
    'UmvnAdministrationPage'
  )
);
export const LazyUoAdministrationPage = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/supervisor-administration/SupervisorAdministrationRoutePages.tsx').then(
        ({ UoAdministrationPage }) => ({ default: UoAdministrationPage })
      ),
    'UoAdministrationPage'
  )
);
export const LazyUdbtfAdministrationPage = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/supervisor-administration/SupervisorAdministrationRoutePages.tsx').then(
        ({ UdbtfAdministrationPage }) => ({ default: UdbtfAdministrationPage })
      ),
    'UdbtfAdministrationPage'
  )
);
export const LazySupervisorContragentBlackListPage = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/covenants/CovenantsEmailBlackList/SupervisorContragentBlackListPage.tsx'),
    'SupervisorContragentBlackListPage'
  )
);
export const LazyMainForm = lazy(() =>
  lazyRetry(() => import('~/modules/identification/MainForm.tsx'), 'MainForm')
);
export const LazyProtectedRoute = lazy(() =>
  lazyRetry(() => import('~/modules/auth/ProtectedRoute.tsx'), 'ProtectedRoute')
);
export const LazyGuaranteesClientLayout = lazy(() =>
  lazyRetry(
    () => import('~/modules/guarantees/layout/GuaranteesClientLayout.tsx'),
    'GuaranteesClientLayout'
  )
);
export const LazyGuaranteesCounterpartySelector = lazy(() =>
  lazyRetry(
    () => import('~/modules/guarantees/form/CounterpartySelector/CounterpartySelector.tsx'),
    'GuaranteesCounterpartySelector'
  )
);
export const LazyGuaranteesClientPage = lazy(() =>
  lazyRetry(() => import('~/modules/guarantees/form/client/ClientPage.tsx'), 'GuaranteesClientPage')
);
export const LazyGuaranteesApplicationPage = lazy(() =>
  lazyRetry(
    () => import('~/modules/guarantees/form/application/client/step1/ClientApplicationPage.tsx'),
    'GuaranteesApplicationPage'
  )
);
export const LazyGuaranteesApplicationStep2Page = lazy(() =>
  lazyRetry(
    () => import('~/modules/guarantees/form/application/client/step2/ClientStep2Page.tsx'),
    'GuaranteesApplicationStep2Page'
  )
);
export const LazyProtectedGuaranteeRoute = lazy(() =>
  lazyRetry(
    () => import('~/modules/guarantees/auth/ProtectedGuaranteeRoute.tsx'),
    'ProtectedGuaranteeRoute'
  )
);
export const LazyProtectedTasksRoute = lazy(() =>
  lazyRetry(() => import('~/modules/tasks/ProtectedTasksRoute.tsx'), 'ProtectedTasksRoute')
);
export const LazyProtectedSupervisorAdministrationRoute = lazy(() =>
  lazyRetry(
    () => import('~/modules/supervisor-administration/ProtectedSupervisorAdministrationRoute.tsx'),
    'ProtectedSupervisorAdministrationRoute'
  )
);
export const LazyGuaranteesApplicationStep3Page = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/guarantees/form/application/client/step3/ClientApprovalLetterSignPage.tsx'),
    'GuaranteesApplicationStep3Page'
  )
);
export const LazyGuaranteesManagerApplicationPage = lazy(() =>
  lazyRetry(
    () => import('~/modules/guarantees/form/application/manager/step1/ManagerApplicationPage.tsx'),
    'GuaranteesManagerApplicationPage'
  )
);
export const LazyGuaranteesManagerApplicationStep2Page = lazy(() =>
  lazyRetry(
    () => import('~/modules/guarantees/form/application/manager/step2/ManagerTermsStep2Page.tsx'),
    'GuaranteesManagerApplicationStep2Page'
  )
);
export const LazyGuaranteesManagerApplicationStep3Page = lazy(() =>
  lazyRetry(
    () => import('~/modules/guarantees/form/application/manager/step3/ManagerStep3Page.tsx'),
    'GuaranteesManagerApplicationStep3Page'
  )
);
export const LazyGuaranteesManagerApplicationStep4Page = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/guarantees/form/application/manager/step4/ManagerApprovalLetterPage.tsx'),
    'GuaranteesManagerApplicationStep4Page'
  )
);
export const LazyGuaranteesManagerUakdoControlPage = lazy(() =>
  lazyRetry(
    () => import('~/modules/guarantees/form/application/manager/step7/UakdoControlPage.tsx'),
    'GuaranteesManagerUakdoControlPage'
  )
);
export const LazyGuaranteesManagerUakdoControllerControlPage = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/guarantees/form/application/manager/step8/UakdoControllerControlPage.tsx'),
    'GuaranteesManagerUakdoControllerControlPage'
  )
);
export const LazyGuaranteesManagerUdbtfGuaranteeScanCopyPage = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/guarantees/form/application/manager/step9/UdbtfGuaranteeScanCopyPage.tsx'),
    'GuaranteesManagerUdbtfGuaranteeScanCopyPage'
  )
);
export const LazyGuaranteesManagerUsapokApprovalPage = lazy(() =>
  lazyRetry(
    () => import('~/modules/guarantees/form/application/manager/step10/UsapokApprovalPage.tsx'),
    'GuaranteesManagerUsapokApprovalPage'
  )
);
export const LazyGuaranteesManagerApplicationManualSignPage = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/guarantees/form/application/manager/step6/ManagerApprovalLetterManualSignPage.tsx'),
    'GuaranteesManagerApplicationManualSignPage'
  )
);
export const LazyGuaranteesManagerApplicationClientSignedPage = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/guarantees/form/application/manager/step6/ManagerApprovalLetterClientSignedPage.tsx'),
    'GuaranteesManagerApplicationClientSignedPage'
  )
);
export const LazyMyTasksPage = lazy(() =>
  lazyRetry(() => import('~/modules/tasks/MyTasksPage.tsx'), 'MyTasksPage')
);

export const LazyGuaranteesUdbtfApprovalLetterPage = lazy(() =>
  lazyRetry(
    () =>
      import('~/modules/guarantees/form/application/manager/step5/InternalApprovalLetterPage.tsx'),
    'GuaranteesInternalApprovalLetterPage'
  )
);

export function lazyRetry<T>(importFn: () => Promise<T>, name: string): Promise<T> {
  return new Promise((resolve, reject) => {
    const key = `retry-${name}-refreshed`;
    const hasRefreshed = sessionStorage.getItem(key) === 'true';

    importFn()
      .then((module) => {
        sessionStorage.removeItem(key);
        resolve(module);
      })
      .catch((error) => {
        if (!hasRefreshed) {
          sessionStorage.setItem(key, 'true');
          window.location.reload();
        } else {
          reject(error);
        }
      });
  });
}
